module.exports = __webpack_public_path__ + "static/index/img/baikal-202.848d8dc4.jpg";